import { render, staticRenderFns } from "./ShopsSelector.vue?vue&type=template&id=4f24e2e9&scoped=true"
import script from "./ShopsSelector.vue?vue&type=script&lang=js"
export * from "./ShopsSelector.vue?vue&type=script&lang=js"
import style0 from "./ShopsSelector.vue?vue&type=style&index=0&id=4f24e2e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f24e2e9",
  null
  
)

export default component.exports